/**
 * <marquee-text> — Infinite horizontal scroll Web Component.
 *
 * Clones the inner track to create a seamless loop, then activates the
 * CSS @keyframes animation. Speed, direction, and pause-on-hover are
 * configured via CSS custom properties set in the Liquid template.
 *
 * The track and scroller are found by data attribute, falling back to the
 * original class names, so other sections can reuse this without adopting
 * scrolling-content's own styling.
 *
 * Used by sections/scrolling-content.liquid and sections/announcement-bar.liquid.
 */

class MarqueeText extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-marquee-track], .scrolling-content__track');
    this.scroller = this.querySelector('[data-marquee-scroller], .scrolling-content__scroller');
    if (!this.track || !this.scroller) return;

    /* Duplicate the track for seamless looping */
    const clone = this.track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    this.scroller.appendChild(clone);

    /* Activate animation after clone is in the DOM */
    this.scroller.classList.add('is-animated');
  }
}

if (!customElements.get('marquee-text')) {
  customElements.define('marquee-text', MarqueeText);
}
